import styled from 'styled-components';

export const StyledPanel = styled.div`
	width: 100%;

	label,
	.label {
		font-size: 1.2rem;
	}

	.course-division,
	.course-discipline {
		margin-bottom: var(--spacing-2);
	}

	.input-container {
		margin-bottom: var(--spacing-2);
		max-width: none;
		width: 100%;
	}

	button[type='submit'] {
		margin: var(--spacing-4) var(--spacing-4) var(--spacing-4) 0;
	}
`;
